// import des images
import EkoLine from '../assets/Portes/PortesPVC/EkoLine.png'
import ClassicLine from '../assets/Portes/PortesPVC/ClassicLine.png'
import EkoVitrePVC from '../assets/Portes/PortesPVC/EkoVitre.png'
import EkoGreen from '../assets/Portes/PortesPVC/EkoGreen.webp'
import PorteModelePVC from '../assets/Portes/PortesPVC/PortesModelePVC.png'
import PanneauxAffleurants from '../assets/Portes/PortesPVC/PanneauxAffleurants.png'

import Despiro from '../assets/Portes/PortesAlu/Despiro.png'
import DespiroRetroLine from '../assets/Portes/PortesAlu/DespiroRetroLine.png'
import PivotLine from '../assets/Portes/PortesAlu/PivotLine.png'
import AluLine from '../assets/Portes/PortesAlu/AluLine.png'
import EkoVitreAlu from '../assets/Portes/PortesAlu/EkoVitre.png'

import WoodLine from '../assets/Portes/PortesBois/WoodLine.png'
import EkoVitreBois from '../assets/Portes/PortesBois/EkoVitreBois.png'
import PanneauxFraisés from '../assets/Portes/PortesBois/PanneauxFraises.png'

export const portes = {
    portesPVC: {
        titre: "Portes d'entrée en PVC",
        // eslint-disable-next-line no-multi-str
        intro: "Les portes en PVC se distinguent par leur esthétique et leur qualité au plus haut niveau. Elles constituent une solution moderne et accessible pour sécuriser et embellir tous types d’habitations. \
        Reconnues pour leur robustesse et leur résistance aux intempéries, elles allient confort, isolation et design. Grâce à une fabrication soignée et des matériaux de qualité, elles garantissent une excellente tenue dans le temps, tout en nécessitant très peu d’entretien.",
        fiche: "/Portes/PortesPVC/Catalogue_Menuitek_Porte_PVC.pdf",// catalogue
        items: [
            {
                titre: "Panneaux EkoLine",
                image: EkoLine,
                presentation: "EkoLine est une collection esthétique de panneaux de porte. Ekoline offre la possibilité de réaliser une porte selon son propre design avec les meilleures solutions de construction.",
                caracteristiques: [
                    "24, 36 et 48mm d'épaisseur",
                    "remplissage dans les versions Classic et Plus",
                    "panneaux en HPL ou en tôle d'aluminium"
                ],
                infos: "Les panneaux EkoLine sont disponibles en version sans capotage, avec un capotage INOX et avec un capotage noir. 144 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux ClassicLine",
                image: ClassicLine,
                presentation: "Le remplissage est produit à partir d'un film en PVC, d'un panneau spécial résistant aux facteurs extérieurs, de colle et de panneau de polyuréthane.",
                caracteristiques: [
                    "remplissage en mousse de polyuréthane",
                    "panneaux de 36 à 44 mm d’épaisseur"
                ],
                infos: "21 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux EkoVitre",
                image: EkoVitrePVC,
                presentation: "EkoVitre signifie non seulement le style, mais aussi sécurité et haute efficacité énergétique. Les panneaux sont constitués de deux feuilles de verre VSG, dont l'une a des motifs sablés.",
                caracteristiques: [
                    "panneaux de 36mm d’épaisseur",
                    "hauteur maximale du panneau 2200 mm",
                    "largeur maximale du panneau 950 mm",
                ],
                infos: "15 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux emboutis EkoGreen",
                image: EkoGreen,
                // eslint-disable-next-line no-multi-str
                presentation: "Ces panneaux de portes au style italien offrant +40 % d’isolation thermique et acoustique par rapport aux modèles classiques. Conçus dans une démarche écologique avec des bois certifiés PEFC et une empreinte carbone réduite, ils allient performance et respect de l’environnement.\
                 Entièrement personnalisables, ils se déclinent en de nombreux styles, finitions et vitrages sécurisés. Grâce à leur technologie avancée — film anti-UV Solar Shield, isolation XPS et HDF imperméable —, ils garantissent des performances optimales, atteignant jusqu’à 0,66 W/m²K, tout en restant légers et durables.",
                caracteristiques: [
                    "panneaux de  24–48 mm d’épaisseur",
                    "dimensions maximales 1100 x 2800 mm",
                    "dimensions minimales 560 x 1770 mm",
                ],
                infos: "51 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Portes modèles en PVC",
                image: PorteModelePVC,
                // eslint-disable-next-line no-multi-str
                presentation: "Cette solution économique allie de bonnes performances thermiques à un design attrayant. Elle offre un excellent rapport qualité-prix, un large choix de modèles et une esthétique parfaitement assortie aux fenêtres PVC. Idéale si vous recherchez un produit efficace et abordable, tout en conservant une parfaite harmonie entre fenêtres et portes.",
                caracteristiques: [
                    
                ],
                infos: "40 versions disponibles. Disponible dans les systèmes Ideal 4000 et Ideal 7000.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux Affleurants",
                image: PanneauxAffleurants,
                // eslint-disable-next-line no-multi-str
                presentation: "Les panneaux affleurants offrent un cadre entièrement couvert en GFK durable, garantissant une isolation thermique et acoustique supérieure. \
                Avec un cadre intérieur en aluminium ou assorti à la couleur, ils facilitent le remplacement du vitrage. Ces portes, chaudes et fiables, sont proposées à prix attractif, avec un large choix de modèles personnalisables et de nombreuses options de taille, couleur, poignées et vitrages, y compris le triple vitrage.",
                caracteristiques: [
                    "panneaux de  36 à 70mm d’épaisseur",
                    "hauteur du panneau de 1500 à 2270 mm (2280 mm pour les panneaux laqués)",
                    "largeur du panneau de 500 à 990 mm",
                ],
                infos: "38 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
        ],
        avantage: "Performance et durabilité",
        // eslint-disable-next-line no-multi-str
        conclusion: "Opter pour une porte d’entrée en PVC, c’est choisir un produit fiable, performant et durable. Offrant une isolation thermique et acoustique de haut niveau, \
        ces portes contribuent à améliorer le confort quotidien et à réduire les pertes d’énergie. Leur conception robuste et leurs options de personnalisation permettent d’allier sécurité, esthétisme et praticité, le tout à un prix attractif. Une solution idéale pour ceux qui recherchent une porte d’entrée efficace, élégante et pérenne.",
    },
    portesAlu: {
        titre: "Portes d'entrée en aluminium",
        // eslint-disable-next-line no-multi-str
        intro: "Les portes en aluminium se caractérisent par une fonctionnalité , une élégance et une durabilité exceptionnelles. Matériau haut de gamme, \
        l’aluminium permet des conceptions fines et épurées tout en garantissant une solidité remarquable face aux chocs et aux intempéries. Grâce à leurs excellentes performances thermiques et acoustiques, ces portes allient confort, sécurité et esthétisme.",
        fiche: "/Portes/PortesAlu/Catalogue_Menuitek_Porte_Alu.pdf",// catalogue
        items: [
            {
                titre: "Panneaux aluminium Despiro",
                image: Despiro,
                presentation: "L'élégante collection de portes extérieures Despiro constitue une offre attractive pour les clients les plus exigeants qui apprécient la modernité non seulement sur le plan technologique mais aussi sur le plan esthétique.",
                caracteristiques: [
                    "77mm d'épaisseur",
                    "dimensions maximales de la construction 1400 x 2600 mm",
                    "2 types de joints du bas"
                ],
                infos: "39 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux aluminium Despiro Retro Line",
                image: DespiroRetroLine,
                presentation: "Les panneaux Despiro Retro Line allient design classique et technologies modernes. Parfaits pour les façades élégantes, ils s’installent dans des cadres classiques ou en aluminium rétro, apportant charme et caractère à la maison.",
                caracteristiques: [
                    "77mm d'épaisseur",
                    "dimensions maximales de la construction 1400 x 2600 mm",
                    "2 types de joints du bas"
                ],
                infos: "9 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux Pivot Line",
                image: PivotLine,
                // eslint-disable-next-line no-multi-str
                presentation: "Les panneaux Pivot Line, destinés aux portes à axe de rotation décalé, allient design prestigieux, matériaux exclusifs et qualité haut de gamme. Leur format possible en très grandes dimensions les rend idéaux pour les maisons, bureaux et \
                bâtiments publics au style moderne. Certaines configurations sont limitées en taille et accessoires — vérifier les options disponibles auprès du service commercial.",
                caracteristiques: [
                    "matériau : aluminium, verre laqué ou pierre frittée",
                    "hauteur maximale : 3100 mm",
                    "largeur maximale : 1800 mm",
                    "éclairage LED blanc (blanc chaud ou froid)"
                ],
                infos: "10 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux AluLine",
                image: AluLine,
                presentation: "La collection de panneaux AluLine combine des motifs populaires avec la durabilité de l'aluminium. AluLine est une gamme aux possibilités illimitées.",
                caracteristiques: [
                    "24, 36 et 48 mm d'épaisseur",
                    "remplissage dans les versions Classic et Plus",
                    "acier inoxydable affleurant la surface du panneau"
                ],
                infos: "Les panneaux AluLine sont disponibles en version avec un capotage INOX et avec un capotage noir. 139 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux EkoVitre",
                image: EkoVitreAlu,
                presentation: "EkoVitre signifie non seulement le style, mais aussi sécurité et haute efficacité énergétique. Les panneaux sont constitués de deux feuilles de verre VSG, dont l'une a des motifs sablés.",
                caracteristiques: [
                    "panneaux de 36mm d’épaisseur",
                    "hauteur maximale du panneau 2200 mm",
                    "largeur maximale du panneau 950 mm",
                ],
                infos: "15 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
        ],
        avantage: "Design et robustesse",
        // eslint-disable-next-line no-multi-str
        conclusion: "Choisir une porte d’entrée en aluminium, c’est opter pour une menuiserie durable, sécurisée et élégante. Sa robustesse garantit une grande longévité sans déformation, \
        tandis que ses performances d’isolation assurent un confort optimal en toute saison. Faciles à personnaliser et disponibles dans un large choix de finitions, les portes en aluminium sont la solution idéale pour ceux qui recherchent un produit alliant esthétisme, fiabilité et modernité.",
    },
    portesBois: {
        titre: "Portes d'entrée en bois",
        // eslint-disable-next-line no-multi-str
        intro: "Les portes en bois sont fabriquées à partir des meilleurs matériaux, spécialement sélectionnés. Elles incarnent l’élégance intemporelle et le charme naturel d’un matériau noble. \
        Chaleureuses et authentiques, elles s’intègrent aussi bien dans les architectures traditionnelles que contemporaines. Grâce à leurs excellentes capacités d’isolation thermique et acoustique, elles allient confort, esthétique et performance.",
        fiche: "/Portes/PortesBois/Catalogue_Menuitek_Porte_bois.pdf",// catalogue
        items: [
            {
                titre: "Panneaux WoodLine",
                image: WoodLine,
                presentation: "La gamme WoodLine associe modernité et praticité aux matériaux traditionnels. Protégées par des vernis haut de gamme, les portes résistent aux intempéries et restent faciles à entretenir. Les teintes peuvent varier selon l’essence de bois, sa couleur naturelle et l’épaisseur du vernis.",
                caracteristiques: [
                    "24, 36 et 48mm d'épaisseur",
                    "Panneaux en contreplaqué et noyau en polystyrène extrudé XPS",
                    "nous collaborons avec des fournisseurs qui détiennent la certification FSC",
                ],
                infos: "Les panneaux WoodLine sont disponibles en version sans capotage, avec un capotage INOX et avec un capotage noir. Disponible en plusieurs couleurs de bois. 139 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux EkoVitre",
                image: EkoVitreBois,
                presentation: "EkoVitre signifie non seulement le style, mais aussi sécurité et haute efficacité énergétique. Les panneaux sont constitués de deux feuilles de verre VSG, dont l'une a des motifs sablés.",
                caracteristiques: [
                    "panneaux de 36mm d’épaisseur",
                    "hauteur maximale du panneau 2200 mm",
                    "largeur maximale du panneau 950 mm",
                    "nous collaborons avec des fournisseurs qui détiennent la certification FSC",
                ],
                infos: "Disponible en plusieurs couleurs de bois. 15 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
            {
                titre: "Panneaux Fraisés",
                image: PanneauxFraisés,
                presentation: "La collection a été conçue pour les adeptes de solutions modernes et pratiques basées sur des matériaux traditionnels. Seuls des vernis de haute qualité garantissent que les portes soient résistantes aux conditions extérieures et faciles à entretenir.",
                caracteristiques: [
                    "panneaux de 24, 36 ou 46mm d’épaisseur",
                    "panneaux en contreplaqué avec l'intérieur rempli de XPS ( polystyrène extrudé )",
                    "nous collaborons avec des fournisseurs qui détiennent la certification FSC",
                ],
                infos: "Disponible en plusieurs couleurs de bois. 12 panneaux disponibles.",
                fiche: null,
                prix: "Chaque projet étant unique, le prix est établi sur devis",
            },
        ],
        avantage: "Authenticité et durabilité",
        // eslint-disable-next-line no-multi-str
        conclusion: "Choisir une porte en bois, c’est miser sur un produit à la fois esthétique, performant et durable. Naturellement isolant, le bois garantit un confort optimal tout en apportant une \
        touche chaleureuse et raffinée à votre habitation. Faciles à personnaliser avec différents styles, teintes et finitions, les portes en bois s’adaptent à toutes les envies et restent une valeur sûre pour allier tradition et modernité."
    }
}